<template>
  <div class="mt-5">
    <px-listagem-cotacao-header :on-click-refresh="onClickRefresh"
                                :on-change-filter="onChangeFilter"
                                @change="onChangeFilter"/>
    <px-lista-cotacao-produtos :produtos="produtos" :loading="loading"
                               :on-change-options="onChangeOptions"
                               :options-list="optionsList"
                               @update="onClickRefresh"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-cotacao/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import CotacoesListagemService from '@/modules/cotacao/listagem/service/cotacoes-listagem-service';
import ListaCotacaoProdutos from '@/modules/cotacao/listagem-produtos/ListaCotacaoProdutos.vue';
import ListagemCotacaoHeader from '../listagem/ListagemCotacaoHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      produtos: {
        content: [],
        total: 0,
      },
      loading: false,
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCotacao', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemCotacao', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getCotacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getCotacoes();
    },
    onClickRefresh() {
      this.getCotacoes();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCotacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CotacoesListagemService.getCotacoesProdutos({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.produtos = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxListagemCotacaoHeader: ListagemCotacaoHeader,
    pxListaCotacaoProdutos: ListaCotacaoProdutos,
  },
};
</script>
